// extracted by mini-css-extract-plugin
export default {"section":"History_section__MR8Zb","wrap":"History_wrap__jiMOU","subtitle":"History_subtitle__LyBFU"};